/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { getCookies } from '../../hooks/useCookies';
import styles from './ToggleButton.module.scss';
import envValues from '../../enviornment';
import { TableContext } from '../../contexts/tableContext';
import ConfirmAlertPopup from '../ConfirmAlertPopUp/ConfirmAlert';

function ToggleButtonOnOff({ value, id, section, onSuccess }) {
  const [isOff, setIsOff] = useState(false);
  const { setActivate } = useContext(TableContext);
  const token = getCookies('Token');
  const manager = getCookies('USERID');
  const [showConfirmModal, setConfirmModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsOff(value);
  }, [value]);

  const handleButtonClick = () => {
    if (section === 'vendor' || section === 'vendorusers') {
      const nextActive = !isOff;
      setIsOff(nextActive);
      setConfirmModal(false);
      const headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
      };
      const body = { active: nextActive, manager };
      axios
        .post(`${envValues.REACT_APP_API_ENDPOINT}/vendor/toggle-change/${id}`, body, headers)
        .then(() => {
          toast.success(
            nextActive
              ? 'Vendor has been enabled successfully.'
              : 'Vendor has been disabled successfully.'
          );
          if (onSuccess) {
            onSuccess();
          } else {
            navigate(-1);
          }
        })
        .catch(() => {
          setIsOff(!nextActive);
          toast.error('Failed to update vendor status. Please try again.');
        });
    } else {
      setIsOff(!isOff);
      setConfirmModal(false);
      const headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
      };
      const body = { token: getCookies('Token'), userid: id, active: !isOff };
      axios
        .post(`${envValues.REACT_APP_API_ENDPOINT}/auth/toggle-change`, body, headers)
        .then(() => {});
    }
  };

  function confirmation() {
    setConfirmModal(true);
  }

  const handleLogoutClose = () => setConfirmModal(false);

  return (
    <div className="col ">
      <ConfirmAlertPopup
        show={showConfirmModal}
        handleClose={handleLogoutClose}
        onConfirm={handleButtonClick}
        onCancel={handleLogoutClose}
      />
      <label className={styles.switch}>
        <input type="checkbox" checked={isOff} onClick={confirmation} />
        <span className={styles.slider} />
      </label>
    </div>
  );
}

ToggleButtonOnOff.propTypes = {
  value: PropTypes.bool,
  id: PropTypes.string,
  section: PropTypes.string,
  onSuccess: PropTypes.func,
};
ToggleButtonOnOff.defaultProps = {
  value: false,
  id: null,
  section: 'User',
  onSuccess: null,
};
export default ToggleButtonOnOff;
